<template>
  <Menu as="div" class="relative inline-block text-left">
    <div>
      <MenuButton
        class="flex h-8 w-8 items-center justify-center rounded-md text-white capitalize-first"
        :class="cButtonClasses"
      >
        <FontAwesomeIcon
          v-if="icon !== null"
          :icon="['fal', icon]"
          :spin="['spinner-third', 'circle-notch'].includes(icon)"
        />
      </MenuButton>
    </div>

    <transition
      enter-active-class="transition duration-100 ease-out"
      enter-from-class="transform scale-95 opacity-0"
      enter-to-class="transform scale-100 opacity-100"
      leave-active-class="transition duration-75 ease-in"
      leave-from-class="transform scale-100 opacity-100"
      leave-to-class="transform scale-95 opacity-0"
    >
      <MenuItems
        class="absolute left-0 z-100 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none"
      >
        <div class="px-1 py-1">
          <MenuItem v-for="item in options" :key="item" v-slot="{ active }">
            <button
              :class="[
                active ? 'bg-gray-500 text-white' : 'text-gray-900',
                'group flex w-full items-center space-x-3 rounded-md px-2 py-2 text-sm',
                cCurentStatut[trackBy] === item[trackBy] ? 'bg-gray-200' : ''
              ]"
              @click="mSelect(item[trackBy])"
            >
              <span
                class="h-3 w-3 flex-shrink-0 rounded-full"
                :class="'bg-theme-' + item[color]"
              ></span>
              <span class="flex-1 text-left capitalize-first">
                {{ item[label] }}
              </span>
              <FontAwesomeIcon
                v-if="cCurentStatut[trackBy] === item[trackBy]"
                class="flex-shrink-0"
                :icon="['fal', 'check']"
              />
            </button>
          </MenuItem>
        </div>
      </MenuItems>
    </transition>
  </Menu>
</template>

<script>
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'DropdownTaskStatusSquare',
  components: {
    FontAwesomeIcon,
    Menu,
    MenuButton,
    MenuItems,
    MenuItem
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    current: {
      required: true
    },
    label: {
      required: false,
      default: 'name'
    },
    icon: {
      required: false,
      default: null
    },
    trackBy: {
      required: false,
      default: 'id'
    },
    color: {
      required: false,
      default: 'bg_color'
    },
    btnStyle: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['select'],
  computed: {
    cCurentStatut() {
      return (
        this.options && this.options.find((item) => item.id === this.current)
      )
    },
    cButtonColor() {
      return this.cCurentStatut && 'bg-theme-' + this.cCurentStatut[this.color]
    },
    cButtonClasses() {
      return [this.cButtonColor]
    }
  },
  methods: {
    mSelect(value) {
      this.$emit('select', {
        [this.trackBy]: value
      })
    }
  }
}
</script>
